import { useState } from "react";

export const EvaluationType = ({ title = "", error = null, click ,mandatory=false}) => {
  const [activeItem, setActiveItem] = useState(-1);

  const handelClik = (_nomC) => {
    click(_nomC);
    console.log(_nomC, "btn");
  };

  const getActualIcon = (index) => {
    let result = <></>;
    if (index === 0)
      result = (
        <img src={"/assets/icons/sad_face_icon.png"} alt="sad_face_icon" />
      );
    else if (index === 7)
      result = (
        <img
          src={"/assets/icons/neutral_face_icon.png"}
          alt="neutral_face_icon"
        />
      );
    else if (index === 10)
      result = (
        <img
          src={"/assets/icons/smiling_face_icon.png"}
          alt="smiling_face_icon"
        />
      );
    return result;
  };

  return (
    <article className="serviceEvaluation-section">
      <h3 className="serviceEvaluation-section-title">
        {title}
        {mandatory && <span className="text-danger serviceEvaluation-section-title">{"*"}</span>}
        {error && <span className="text-danger serviceEvaluation-section-title">{error}</span>}
      </h3>
      <div className="flex flex-col">
        <div className="serviceEvaluation-section-map">
          {[...Array(11)].map((num, index) => {
            return (
              <div
                key={`service-evaluation-icons-${index}`}
                className={`serviceEvaluation-section-icons-item`}
              >
                {getActualIcon(index)}
              </div>
            );
          })}
        </div>

        <div className="serviceEvaluation-section-map">
          {[...Array(11)].map((num, index) => {
            return (
              <div
                key={`service-evaluation-${index}`}
                className={`serviceEvaluation-section-map-item ${
                  activeItem === index && "item-active"
                }`}
                onClick={() => {
                  handelClik(index);
                  setActiveItem(index);
                }}
              >
                <span className="text-20">{index}</span>
              </div>
            );
          })}
        </div>
      </div>
    </article>
  );
};
